import React from 'react'
import { Trans } from '@lingui/macro'
import { SOLIDSPORT_SUPPORT_URL } from 'pages/rateLimitPage/consts'

import classes from './SupportText.module.scss'

export const SupportText = () => {
  return (
    <p className={classes.SupportText}>
      <Trans>Need more help?</Trans>{' '}
      <a
        href={SOLIDSPORT_SUPPORT_URL}
        target="_blank"
        rel="noopener noreferrer"
        className={classes.SupportLink}
      >
        <Trans>Contact support</Trans>
      </a>
    </p>
  )
}
